import axiosIns from "@/api/axios";

export const GET_ALL_DATA = (args) => {
    return axiosIns.get(`files`);
    //   return axiosIns.get(`files?${args}`);
};
export const GET_ALL_IDEATION = (args) => {
    return axiosIns.get(`ideations`);
    //   return axiosIns.get(`files?${args}`);
};

export const ADD_DATA = (args) => {
    return axiosIns.post(`files`, args, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
};

export const UPDATE_DATA = (args) => {
    return axiosIns.put(`files/${args.id}`, args.formdata, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`files/${id}`);
};

export const DELETE_FILES = (body) => {
    return axiosIns.delete(`files/${body.id}/${body.name}`);
};

export const SUBMIT_RFI_VENDOR = (args) => {
    return axiosIns.put(`ideation/submit-rfi?rfi_code=${args.code}`, args);
}